import React from 'react';
import JobWizardPage from '../JobWizard';

const ForemanREXRoutes = [
  {
    path: '/experimental/job_wizard',
    exact: true,
    render: props => <JobWizardPage {...props} />,
  },
];

export default ForemanREXRoutes;



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/Routes/routes.js